import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, AuthGate, AuthRedirectHandler } from '@/components/auth/AuthProvider';
import { AppShell } from '@/components/layout/AppShell';
import { VehicleSelectPage } from '@/components/inspection/VehicleSelectPage';
import { InspectionFormPage } from '@/components/inspection/InspectionFormPage';
import { ReviewPage } from '@/components/inspection/ReviewPage';
import { VehiclesPage } from '@/components/inspection/VehiclesPage';
import { AdminDashboard } from '@/components/admin/AdminDashboard';
import { ProfilePage } from '@/components/common/ProfilePage';
import { RequireRole } from '@/components/auth/RequireRole';
import { VehiclePhotoPage } from "@/components/inspection/VehiclePhotoPage";
import { InspectionTypePage } from '@/components/inspection/InspectionTypePage';
import { AuthInit } from './components/auth/AuthInit';

export default function App() {
  return (
    <AuthProvider>
      <AuthInit />
      <BrowserRouter>
        <Routes>
          {/* /auth must be outside AuthGate so MSAL can process the token */}
          <Route path="/auth" element={<AuthRedirectHandler />} />

          {/* All protected routes go inside AuthGate */}
          <Route path="/*" element={
            <AuthGate>
              <Routes>
                <Route element={<AppShell />}>
                  <Route path="/" element={<VehicleSelectPage />} />
                  <Route path="/inspect/type" element={<InspectionTypePage />} />
                  <Route path="/inspect/photos" element={<VehiclePhotoPage />} />
                  <Route path="/inspect" element={<InspectionFormPage />} />
                  <Route path="/inspect/review" element={<ReviewPage />} />
                  <Route path="/vehicles" element={<VehiclesPage />} />
                  <Route path="/admin" element={<RequireRole roles={['Admin']}>
                    <AdminDashboard />
                  </RequireRole>} />
                  <Route path="/profile" element={<ProfilePage />} />
                </Route>
              </Routes>
            </AuthGate>
          } />
        </Routes>
        <Toaster
          position="top-center"
          toastOptions={{
            className: 'text-sm font-medium',
            duration: 3000,
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}